import {
    Autocomplete,
} from '@mui/material';
import React from 'react';
import CustomDialog from '../../sharedcomponents/dialog/dialog';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import TextField from '@mui/material/TextField';
import { useState } from '@hookstate/core';
import Title from '../../sharedcomponents/title/title';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import { useEffect } from 'react';
import Helper from '../../utility/helper';

// const loader = {
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     height: '100%',
//     width: '100%',
// };

const EditRosters = (props) => {
    // console.log("props", props);
    const loading = useState(false);
    // const [disableBtn, setDisableBtn] = React.useState(true);
    const teams = useState([]);

    const [teamValue, setTeamValue] = React.useState('');

    useEffect(async () => {
        if(props.eventUserInfo.team !== "" || props.eventUserInfo.team !== null){
            setTeamValue(props.eventUserInfo.team)
        }       
        const eventInfo = Helper.getStorage('eventInfo');

        ApiHelper.get(
            APIURLConstants.GET_ROSTER_TEAMS(
                eventInfo.eventID
            )
        )
            .then((res) => {
                if (res.data.value) {
                    teams.set(res.data.value)
                }
                // console.log("res", res.data.value);
            })
    }, []);

    const renderDialogContent = () => {
        return (
            <>
                {(
                    <>
                        <Title
                            title={`User : ${props.eventUserInfo && props.eventUserInfo.playerName}`}
                            sx={{
                                ml: 0,
                            }}
                            px={0}
                        />
                        <Title
                            title="Select Team"
                            sx={{
                                ml: 0,
                                pt: 2,
                                pb: 1,
                            }}
                            px={0}
                        />
                        <Autocomplete
                            id="select team"
                            value={teamValue}
                            freeSolo
                            size='small'
                            onChange={(event, newValue) => {
                                // console.log("newValue", newValue);
                                if (typeof newValue === 'string') {
                                    setTeamValue(
                                        newValue,
                                    );
                                } else if (newValue && newValue.inputValue) {
                                    // Create a new value from the user input
                                    setTeamValue(
                                        newValue.inputValue,
                                    );
                                } else {
                                    setTeamValue(newValue);
                                }
                            }}
                            options={teams.get().map((option) => option.teamName)}
                            renderInput={(params) => <TextField
                                onChange={(event) => {
                                    setTeamValue(event.target.value)
                                }}
                                {...params}

                                label="Team"
                            />}
                        />

                    </>
                )}
            </>
        );
    };
    // console.log("teamValue", teamValue);
    const handleClick = () => {
        
        const eventInfo = Helper.getStorage('eventInfo');
        let playerIds = []
        // console.log("props.eventUserInfo", props.eventUserInfo);
        if (teamValue.trim() === "") {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select/create Team',
            });
        } else {
            loading.set(true);
            props.eventUserInfo &&
                playerIds.push(props.eventUserInfo.playerID)
            let requestObj = {
                playerIDs: playerIds,
                eventId: eventInfo.eventID,
                team: teamValue,
            };
            // console.log("requestObj", requestObj);
            ApiHelper.post(APIURLConstants.UPDATE_PLAYER_TEAM, requestObj)
                .then((res) => {
                    if (res.data) {

                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: 'Participant updated successfully',
                        });
                        props.handleClose();
                        props.getRosterManagement();
                    }
                    //}
                })
                .catch((error) => {
                    console.log('error : ', error);
                    let message = '';
                    if (error.response && error.response.status === 401) {
                        message = 'Access denied';
                    } else {
                        message = 'Error while updating roster';
                    }
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                    props.handleClose();
                    props.getRosterManagement();
                });

        }


    };

    const renderDialogActions = () => {
        return (
            <ButtonContainer
                showLoading={true}
                loading={loading.get()}
                handleClick={handleClick}
                handleCancel={props.handleClose}
                buttonText={'Update'}
            // disableUpdateButton={disableBtn}
            />
        );
    };

    return (
        <CustomDialog
            title={props.title}
            handleClose={props.handleClose}
            open={props.open}
            fullWidth={true}
            renderContent={renderDialogContent}
            renderActions={renderDialogActions}
        />
    );
};

export default EditRosters;
